import { useEffect, useState } from 'react';
import axios from 'axios';
import './tableStyles.css';
import CustomAlert from './CustomAlert';
import BACKEND_URL from '../config';
import { FaSearch, FaTimes } from "react-icons/fa";

const BookedShipmentsTable = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [columnNames, setColumnNames] = useState([]);
    const [error, setError] = useState('');
    const [alert, setAlert] = useState({ show: false, title: '', message: '' });
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BACKEND_URL}/api/booked-shipments`, {
                    withCredentials: true,
                });
                setColumnNames(response.data.column_names);
                setData(response.data.data);
                setFilteredData(response.data.data);
            } catch (error) {
                setError('Error fetching data');
                console.error('Error fetching data:', error);
                handleShowAlert('Error', 'Failed to fetch data');
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (searchQuery === '') {
            setFilteredData(data);
        } else {
            setFilteredData(
                data.filter(row =>
                    columnNames.some(col => 
                        row[col] && row[col].toString().toLowerCase().includes(searchQuery.toLowerCase())
                    )
                )
            );
        }
    }, [searchQuery, data, columnNames]);

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleShowAlert = (title, message) => {
        setAlert({ show: true, title, message });
    };

    const handleCloseAlert = () => {
        setAlert({ show: false, title: '', message: '' });
    };

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="table-container">
            <h1>Booked Shipments</h1>

            <div className="search-bar-wrapper">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    {searchQuery ? (
                        <FaTimes className="clear-icon" onClick={() => setSearchQuery('')} />
                    ) : (
                        <FaSearch className="search-icon" />
                    )}
                </div>
            </div>

            <div className="table-content-container">
                <table>
                    <thead>
                        <tr>
                            {columnNames.map((col, index) => (
                                <th key={index}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columnNames.map((col, cellIndex) => (
                                    <td key={cellIndex}>{row[col] != null ? row[col] : ''}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <CustomAlert
                show={alert.show}
                handleClose={handleCloseAlert}
                title={alert.title}
                message={alert.message}
            />
        </div>
    );
};

export default BookedShipmentsTable;
